import UsersContainer from './usersContainer';

var User = {
	UsersContainer,
}

export default User;


// WEBPACK FOOTER //
// ./src/browser/components/users/user.js